// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2p2zC","footer":"ModalError_footer__2IhG6"};